<template>
  <li
    class="panel"
    v-editable="item"
  >
    <div class="the-container">
      <div class="the-grid">
        <div class="col-media">
          <Media :blok="item.media" />
          <RivePlayer
            :src="riveSrc"
            v-if="riveSrc"
          />
        </div>
        <div class="col-top">
          <div class="head">
            <div class="heading type-h2">{{ item.heading }}</div>
            <!-- <div class="num type-mono mobile-only">
              {{ (props.idx + 1).toString().padStart(2, "0") }}
              <span class="fade">
                / {{ props.total.toString().padStart(2, "0") }}</span
              >
            </div> -->
          </div>
          <div class="body type-body3">{{ item.desc }}</div>
        </div>
        <div class="num type-mono">
          {{ (props.idx + 1).toString().padStart(2, "0") }}
          <span class="fade">
            / {{ props.total.toString().padStart(2, "0") }}</span
          >
        </div>
        <ul class="col-tags type-mono">
          <li
            v-for="tag of tags"
            :key="tag"
            class="tag"
          >
            {{ tag }}
          </li>
        </ul>
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
const props = defineProps({
  item: {
    required: true,
  },
  idx: {
    type: Number,
    required: true,
  },
  total: {
    type: Number,
    required: true,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const tags = computed(() => {
  return props.item.tags.split("\n")
})

const riveSrc = computed(() => {
  if (!props.item.riveId) return null
  return `/rives/${props.item.riveId}.riv`
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.panel {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  background: $cl-black;
  color: $cl-light;
  padding-block: $p5;
}

.col-media {
  position: relative;
  grid-column: 1 / span 6;
  aspect-ratio: 1;
  width: 100%;
  max-height: calc(100lvh - #{$p10});
  // background: rgba($cl-light, 0.15);
  grid-row: 1 / span 2;

  :deep(.media) {
    @include fill;
    object-fit: contain;
  }

  :deep(.rive-player) {
    @include fill;
    background: black;
  }
}

.col-top {
  grid-column: 7 / span 5;
}

.head {
  position: relative;
  width: 100%;
  @include flex(row, space-between, flex-start);
}

.col-tags {
  grid-column: 9 / -1;
  display: grid;
  height: fit-content;
  grid-template-columns: repeat(2, 1fr);
  align-self: flex-end;
  gap: 0 var(--grid-column-gap);
}

.tag {
  display: block;
  padding-block: 2.1rem;
  border-top: 1px solid rgba($cl-light, 0.2);
  // color: rgba($cl-light, 0.6);
}

.num {
  white-space: nowrap;
  .fade {
    color: rgba($cl-light, 0.4);
  }
}

@include mobile {
  .panel {
    @include fill;
    padding-top: var(--nav-height);
  }

  .the-container,
  .the-grid {
    @include flex(column, flex-start, flex-start);
    height: 100%;
  }

  .col-media {
    flex: 1;
    order: 2;
    width: 100%;
    height: auto;
    aspect-ratio: auto;
    margin-block: $p2;
  }

  .num {
    position: absolute;
    // top: var(--nav-height);
    top: $p0;
    right: 0;
  }

  .col-top {
    display: contents;
  }

  .body {
    order: 3;
    text-wrap: balance;
  }

  .col-tags {
    order: 4;
    margin-top: $p2;
    width: 100%;
  }

  .tag {
  }
}
</style>
